<template>

  <svg
    t="1632727249533"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4083"
    width="64"
    height="64"
  ><path d="M512 124L64 900h896z" p-id="4084" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconShapeTriangle',
} as DefineComponent
</script>